import "./init-app.js";

export default {
  Payment: () => import("./components/Share/Payment.vue"),
  SetupPayment: () => import("./components/Share/SetupPayment.vue"),
  Signup: () => import("./components/Share/InstanceSignup/Signup.vue"),
};